import React from "react";
import { useTranslation } from "react-i18next";
import TableHeadGen from "../TableHeadGen";
import styles from "./Table.module.scss";

export default function Table({
  columns,
  children,
  empty = false,
  emptyMessage,
  ...tableProps
}) {
  const { t } = useTranslation("common");

  return (
    <table {...tableProps}>
      <TableHeadGen columns={columns} />
      <tbody>
        {empty ? (
          <tr>
            <td colSpan={columns.length} className={styles.emptyCell}>
              {emptyMessage ?? t("components.table.noEntries")}
            </td>
          </tr>
        ) : (
          children
        )}
      </tbody>
    </table>
  );
}
